interface TableFiltersBarProps {
  searchInput: string
  statusFilter: string
  categoryFilter: string
  priorityFilter: string
  limitVal: number
  rowsCount: number
  total: number | undefined
  onSearchChange: (v: string) => void
  onStatusChange: (v: string) => void
  onCategoryChange: (v: string) => void
  onPriorityChange: (v: string) => void
  onLimitChange: (v: number) => void
  onReset: () => void
}

export function TableFiltersBar({
  searchInput,
  statusFilter,
  categoryFilter,
  priorityFilter,
  limitVal,
  rowsCount,
  total,
  onSearchChange,
  onStatusChange,
  onCategoryChange,
  onPriorityChange,
  onLimitChange,
  onReset,
}: TableFiltersBarProps) {
  const hasFilters = !!(searchInput || statusFilter || categoryFilter || priorityFilter)

  const controlStyle = {
    padding: '4px 10px',
    fontSize: 12,
    border: '1px solid var(--border-strong)',
    borderRadius: 6,
    background: 'var(--bg-panel)',
    color: 'var(--text)',
  } as const

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
        flexShrink: 0,
        background: 'var(--bg-app)',
        border: '1px solid var(--border)',
        borderRadius: 10,
        padding: '8px 12px',
        alignItems: 'center',
      }}
    >
      <input
        type="text"
        placeholder="🔍 Поиск по арт./бренду..."
        value={searchInput}
        onChange={(e) => onSearchChange(e.target.value)}
        style={{ ...controlStyle, width: 200, outline: 'none' }}
      />
      <select
        value={statusFilter}
        onChange={(e) => onStatusChange(e.target.value)}
        style={{ ...controlStyle, padding: '4px 8px' }}
      >
        <option value="">Все статусы</option>
        <option value="NEW">NEW</option>
        <option value="IN_QUEUE">IN_QUEUE</option>
        <option value="IN_PROGRESS">IN_PROGRESS</option>
        <option value="NEEDS_INFO">NEEDS_INFO</option>
        <option value="QUOTED">QUOTED</option>
        <option value="PARTIAL">PARTIAL</option>
        <option value="READY_FOR_QUOTATION">READY_FOR_QUOTATION</option>
        <option value="REWORK">REWORK</option>
        <option value="NOT_ACTUAL">NOT_ACTUAL</option>
        <option value="CANCELLED">CANCELLED</option>
      </select>
      <select
        value={categoryFilter}
        onChange={(e) => onCategoryChange(e.target.value)}
        style={{ ...controlStyle, padding: '4px 8px' }}
      >
        <option value="">Все категории</option>
        <option value="A">A</option>
        <option value="B">B</option>
        <option value="C">C</option>
      </select>
      <select
        value={priorityFilter}
        onChange={(e) => onPriorityChange(e.target.value)}
        style={{ ...controlStyle, padding: '4px 8px' }}
      >
        <option value="">Все приоритеты</option>
        <option value="HIGH">🔴 Высокий</option>
        <option value="MEDIUM">🟡 Средний</option>
        <option value="LOW">⚪ Базовый</option>
      </select>
      <select
        value={limitVal}
        onChange={(e) => onLimitChange(Number(e.target.value))}
        style={{ ...controlStyle, padding: '4px 8px' }}
      >
        <option value={100}>100 строк</option>
        <option value={500}>500 строк</option>
        <option value={1000}>1000 строк</option>
        <option value={0}>Все строки</option>
      </select>
      {hasFilters && (
        <button
          onClick={onReset}
          style={{
            ...controlStyle,
            cursor: 'pointer',
            color: 'var(--text-muted)',
          }}
        >
          ✕ Сбросить
        </button>
      )}
      {total !== undefined && (
        <span style={{ fontSize: 11, color: 'var(--text-faint)', marginLeft: 'auto' }}>
          {rowsCount} / {total} позиций
        </span>
      )}
    </div>
  )
}
